import React from "react"
import { ControlLabel, FormControl, FormGroup, HelpBlock, InputGroup } from "react-bootstrap"

export default function FormControlInput({ id, label, help, onChange, validationState,
  hasFeedback, addOn, className, ...props }) {

  return (
    <FormGroup controlId={ id } validationState={ validationState } className={ className }>
      <ControlLabel>{ label }</ControlLabel>
      <InputGroup>
        <FormControl id={ id } onChange={e => onChange ? onChange(e.target.value) : null} {...props}  />
        { addOn && <InputGroup.Addon>{ addOn }</InputGroup.Addon> }
      </InputGroup>
      { hasFeedback && <FormControl.Feedback /> }
      { help && <HelpBlock> { help } </HelpBlock> }
    </FormGroup>
  )
}



// WEBPACK FOOTER //
// ./src/components/fragments/FormControl.Input.js